<template>
    <div>
        <div class="col-lg-12" style="" v-if="mealPlan">

            <!-- <h4>Meal Program: {{ mealPlan.meal_program.name }}</h4> -->
            <div class="btn-group mb-2">
              <button type="button" class="btn btn-default btn-lg dropdown-toggle ml-0 pl-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Meal Program: {{ mealPlan.meal_program.name }}
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <button
                    v-for="(mealProgram, index) in availableMealPrograms"
                    v-bind:key="index"
                    :disabled="mealPlan.meal_program_id == mealProgram.id"
                    class="dropdown-item"
                    type="button"
                    @click="changeMealProgram(mealProgram)"
                >{{ mealProgram.name }}</button>
              </div>
            </div>
            <div class="alert alert-info" v-if="mealPlanIsApproved" >
                This meal plan was approved by {{ mealPlan.approved_by.first_name }} {{ mealPlan.approved_by.last_name }} on {{ mealPlan.approved_at | moment("M/DD/YYYY hh:mm a")}}
            </div>
            <div class="alert alert-danger" v-if="!mealPlanCanBeApproved">
                <ul class="mb-0">
                    <li v-if="!allDaysWithinFivePercentOfTargetCaloriesAndMacros">All days not within macro range</li>
                    <li v-if="!allMealsWithinFivePercentOfTargetCalories">All meals not within calorie range</li>
                </ul>
            </div>
            <div v-if="!isLoading">
                <div v-for="(week, index) in mealPlan.weeks" v-bind:key="index">
                    <mealplan-week-component :initial-week="week" @week-updated="weekUpdated"></mealplan-week-component>
                </div>
            </div>

            <div class="text-center">
                <button class="btn btn-secondary mt-2" :disabled="!mealPlanCanBeApproved" @click.prevent="approveMealPlan()">Approve Meal Plan</button>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    props: [
        'initialMealPlan'
    ],
    data() {
        return {
            mealPlan: this.initialMealPlan,
            program: null,
            showModal: false,
            isLoading: false
        }
    },
    mounted() {
    },
    computed: {
        availableMealPrograms: function() {
            return this.$root.availableMealPrograms;
        },
        allMealsWithinFivePercentOfTargetCalories: function() {
            var result = true;
            // if (_.isNull(this.mealPlan)) {
            //     return false;
            // }
            _.each(this.mealPlan.weeks, function(week) {
                _.each(week.days, function(day) {
                    _.each(day.meals, function(meal) {
                        if (!within5pct(meal.target_calories, meal.calories)) {
                            result = false;
                        }
                    });
                });
            });

            return result;
        },
        allMealsHaveFoodsAssigned: function() {
            var result = true;
            _.each(this.mealPlan.weeks, function(week) {
                _.each(week.days, function(day) {
                    _.each(day.meals, function(meal) {
                        if (meal.foods.length == 0){
                            result = false;
                            return;
                        }
                    });
                });
            });
            return result;
        },
        allDaysWithinFivePercentOfTargetCaloriesAndMacros: function() {
            var result = true;

            // if (_.isNull(this.mealPlan)) {
            //     return false;
            // }
            _.each(this.mealPlan.weeks, function(week) {
                _.each(week.days, function(day) {
                    if (!within5pct(day.target_calories, day.calories)
                        || !within5pct(day.target_protein_g, day.protein_g)
                        || !within5pct(day.target_carbohydrate_g, day.carbohydrate_g)
                        || !within5pct(day.target_fat_g, day.fat_g)
                    ) {
                        result = false;
                    }
                });
            });

            return result;
        },
        mealPlanCanBePreviewed: function() {
            return true;
        },
        mealPlanCanBeApproved: function() {

            // Are all the weeks built?
            // Are all the days built?
            // Do all the days have meals?
            // Do all the meals have foods?
            // Are all the foods selected?
            // Are there any undismissed notices?
            // Is the status open? Not cancelled?
            return this.allMealsHaveFoodsAssigned;
            // return this.allMealsWithinFivePercentOfTargetCalories
                // && this.allDaysWithinFivePercentOfTargetCaloriesAndMacros;
        },
        mealPlanIsApproved: function() {
            return this.mealPlan.approved_at != null;
        },
    },
    methods: {
        // getAvailableMealPrograms: function getAvailableMealPrograms() {
        //     var _this = this;
        //     _this.isLoading = true;

        //     axios.get('/api/program/' + _this.mealPlan.program_id).then(function (response) {
        //         _this.program = response.data.data;
        //         _this.isLoading = false;
        //     });
        // },
        getMealPlan: function getMealPlan() {
            var _this = this;
            _this.isLoading = true;

            axios.get('/api/meal_plans/' + _this.mealPlan.id).then(function (response) {
                _this.mealPlan = response.data.data;
                _this.isLoading = false;
            });
        },
        changeMealProgram: function(mealProgram) {
            var _this = this;
            _this.isLoading = true;

            axios.post('/api/meal_plans/' + _this.mealPlan.id +'/update_meal_program',{
                'meal_program_id': mealProgram.id
            }).then(function (response) {
                _this.mealPlan = response.data.data;
                _this.isLoading = false;
            });
        },
        approveMealPlan: function() {
            var _this = this;
            _this.isLoading = true;

            axios.put('/api/meal_plans/' + _this.mealPlan.id, {
                approve: true,
            }).then(function (response) {
                _this.mealPlan = response.data.data;
                _this.isLoading = false;
                _this.$toasted.success("Meal Plan Approved!")
                _this.$emit('mealplan-updated', _this.mealPlan);
            })
            .catch(e => {
                _this.$toasted.error(e.response.data.message);
                _this.isLoading = false;
            })
        },
        weekUpdated: function() {
            var _this = this;
            axios.get('/api/meal_plans/' + _this.mealPlan.id).then(function (response) {
                _this.mealPlan = response.data.data;
            });
        },
    },
    watch: {
        initialMealPlan: function (newVal,oldVal) {
            Vue.set(this, 'mealPlan', newVal);
        }
    }
}
</script>
